import { Action } from '@ngrx/store'
import * as SettingsTypes from './settings.types'
import { Settings } from './settings.interface'

export class FetchSettingsRequest implements Action {
  readonly type = SettingsTypes.FETCH_SETTINGS_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchSettingsSuccess implements Action {
  readonly type = SettingsTypes.FETCH_SETTINGS_SUCCESS
  constructor(public payload: Settings) {}
}

export class FetchSettingsFailure implements Action {
  readonly type = SettingsTypes.FETCH_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateSettingsRequest implements Action {
  readonly type = SettingsTypes.UPDATE_SETTINGS_REQUEST
  constructor(public payload) {}
}

export class UpdateSettingsSuccess implements Action {
  readonly type = SettingsTypes.UPDATE_SETTINGS_SUCCESS
  constructor() {}
}

export class UpdateSettingsFailure implements Action {
  readonly type = SettingsTypes.UPDATE_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = SettingsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = SettingsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateSettingsRequest
  | UpdateSettingsSuccess
  | UpdateSettingsFailure
  | FetchSettingsSuccess
  | FetchSettingsFailure
  | FetchSettingsRequest
  | SetDefaultData
  | UpdateField
